import React from 'react';
import './EMS.css';
import FMSimage from '../Assets/EMS.jpg'; // First image (full size)
import FMSimage2 from '../Assets/energy1.jpg'; // Image for Key Features & Benefits
import FMSimage3 from '../Assets/energy2.jpg'; // Image for How it Works section
import FMSimage4 from '../Assets/energy3.jpg'; // Image for Why Choose section
import FMSimage5 from '../Assets/energy4.jpg'; // Image for Industries section

const FMS = () => {
    return (
        <div className="FMS-container">
            {/* First Section: Layout for Text and Image */}
            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <h1 className="FMS-heading">ENERGY MONITORING SYSTEM</h1>
                    <p className="FMS-description">
                        The Energy Monitoring System (EMS) from Vajra IoT is a state-of-the-art solution 
                        designed to monitor and manage energy usage efficiently. It helps businesses and industries 
                        optimize energy consumption, reduce operational costs, and achieve sustainability goals. 
                        With real-time energy tracking and insights, EMS empowers organizations to identify 
                        energy wastage and implement corrective measures for improved efficiency and savings.
                    </p>
                </div>

                {/* Right side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage} alt="Energy Monitoring System" className="FMS-image full-size" />
                </div>
            </div>

            {/* Centered Heading Between Images */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Key Features & Benefits</h2>
            </div>

            {/* Second Section: New Layout for Text and Image */}
            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        <ul>
                            <li><strong>Real-Time Monitoring:</strong> Gain instant insights into energy usage across various systems and locations.</li>
                            <li><strong>Cost Optimization:</strong> Identify and eliminate energy wastage, reducing operational expenses significantly.</li>
                            <li><strong>Customizable Reports:</strong> Generate tailored reports to analyze energy trends and optimize resource allocation.</li>
                            <li><strong>Seamless Integration:</strong> Easily integrate with existing systems for comprehensive energy management.</li>
                            <li><strong>Environmental Sustainability:</strong> Monitor carbon footprints and contribute to eco-friendly initiatives.</li>
                        </ul>
                    </p>
                </div>

                {/* Right side: New Image for Key Features */}
                <div className="FMS-image-container">
                    <img src={FMSimage2} alt="Key Features" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* Centered Heading for How it Works */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">How it Works</h2>
            </div>

            {/* Third Section: Layout for How it Works */}
            <div className="FMS-content-container">
                {/* Left side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage3} alt="How It Works" className="FMS-image smaller-size" />
                </div>

                {/* Right side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        <ul>
                            <li><strong>Data Collection:</strong> Sensors and IoT devices collect real-time energy usage data from all connected systems.</li>
                            <li><strong>Data Analysis:</strong> The EMS platform analyzes energy consumption patterns to detect inefficiencies.</li>
                            <li><strong>Alerts & Notifications:</strong> Automated alerts notify users of anomalies or excessive energy consumption.</li>
                            <li><strong>Actionable Insights:</strong> Provides actionable recommendations to reduce energy waste and enhance performance.</li>
                            <li><strong>Control & Automation:</strong> Enables remote control of devices and automation for optimal energy usage.</li>
                        </ul>
                    </p>
                </div>
            </div>

            {/* New Section: Why Choose Us */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Why Choose Our Energy Monitoring System</h2>
            </div>

            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        <ul>
                            <li><strong>Energy Efficiency:</strong> Monitor and optimize energy usage to achieve maximum efficiency.</li>
                            <li><strong>Cost Savings:</strong> Significantly reduce energy costs with detailed tracking and analytics.</li>
                            <li><strong>Environmental Impact:</strong> Contribute to sustainability by minimizing carbon emissions.</li>
                            <li><strong>User-Friendly Interface:</strong> Easy-to-use web platform accessible from any device.</li>
                        </ul>
                    </p>
                </div>

                {/* Right side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage4} alt="Why Choose Us" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* New Section: Industries Using Our EMS */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Industries Using Our System</h2>
            </div>

            <div className="FMS-content-container reverse-order-last">
                {/* Left side: Image for Industries */}
                <div className="FMS-image-container">
                    <img src={FMSimage5} alt="Industries Using EMS" className="FMS-image smaller-size" />
                </div>

                {/* Right side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        Our Energy Monitoring System is trusted by various industries to achieve energy efficiency, sustainability, and cost savings:
                        <ul>
                            <li>Manufacturing & Production</li>
                            <li>Commercial Buildings</li>
                            <li>Data Centers</li>
                            <li>Hospitality & Retail</li>
                            <li>Renewable Energy Management</li>
                        </ul>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default FMS;
